import React, { useState } from "react";
import { toast } from "react-toastify";
import Layout from "../../components/Layout/Layout";
import {
  getAllStaff,
  getProductData,
  getProductIncentive,
  updateProductIncentive,
} from "../../utils/api";

const StaffIncentiveProducts = () => {
  const [loading, setLoading] = useState(false);
  const [incentiveAmount, setIncentiveAmount] = useState(0);
  const [staff, setStaff] = useState(null);
  const [incentive, setIncentive] = useState(null);
  const [product, setProduct] = useState(null);
  const [staffList, setStaffList] = useState([]);
  const [products, setProducts] = useState([]);

  const getAllStaffHandler = async () => {
    setLoading(true);
    const [success, data] = await getAllStaff();
    if (success) {
      setStaffList(data);
    }
    setLoading(false);
  };

  const getProductsData = async () => {
    setLoading(true);
    const [success, data] = await getProductData();
    if (success) {
      setProducts(data);
    }
    setLoading(false);
  };

  const [search, setSearch] = useState("");

  const getProductIncentiveData = async (data) => {
    setLoading(true);
    const [success, data2] = await getProductIncentive(data);
    if (success) {
      setIncentive(data2);
      if (data2) {
        setIncentiveAmount(data2?.incentive);
      } else {
        setIncentiveAmount(0);
      }
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getAllStaffHandler();
    getProductsData();
  }, []);

  return (
    <Layout>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="border p-3 rounded bg-white border-black">
          <h2 className="border-b pb-3">Staff</h2>
          <div className="flex gap-2 my-3">
            <input
              type="text"
              placeholder="Search"
              className="border border-black flex-1 w-full rounded p-2"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>
          <div className="flex flex-col gap-2 ">
            {staffList?.length === 0 && (
              <p className="text-center">No Staff Found</p>
            )}
          </div>
          <div className="flex flex-col gap-2">
            {staffList?.map((item, index) => (
              <button
                className={`flex gap-2 py-1
                ${
                  staff?.userName === item.userName
                    ? "bg-primary text-white px-2 rounded"
                    : "bg-white text-black"
                }
                `}
                key={index}
                onClick={() => {
                  setStaff(item);
                  if (product) {
                    getProductIncentiveData({
                      staffId: item?._id,
                      productId: product?._id,
                    });
                  }
                }}
              >
                <p>{item.userName}</p>
              </button>
            ))}
          </div>
        </div>
        <div className="border p-3 rounded bg-white border-black">
          <h2 className="border-b pb-3">Products</h2>
          <div className="flex flex-col gap-2 mt-3">
            {products
              ?.filter((item) => item?.productType === "Sale")
              ?.map((item, index) => (
                <button
                  className={`flex gap-2 py-1
                ${
                  product?.productName === item.productName
                    ? "bg-primary text-white px-2 rounded"
                    : "bg-white text-black"
                }
                    `}
                  key={index}
                  onClick={() => {
                    setProduct(item);
                    if (staff) {
                      getProductIncentiveData({
                        staffId: staff?._id,
                        productId: item?._id,
                      });
                    }
                  }}
                >
                  <p>{item.productName}</p>
                </button>
              ))}
          </div>
        </div>
        <div className="border p-3 rounded bg-white border-black">
          <div className="flex flex-col gap-3">
            <h2 className="border-b pb-3">Incentive</h2>
            <div className="flex flex-col gap-2 mt-3">
              <input
                type="number"
                placeholder="Incentive Amount"
                className="border border-black rounded p-2"
                disabled={!product || !staff}
                value={incentiveAmount}
                onChange={(e) => {
                  setIncentiveAmount(e.target.value);
                }}
              />
              <div className="flex justify-between items-center">
                <button
                  className="bg-primary text-white rounded p-2 ml-auto"
                  disabled={!product || !staff}
                  onClick={async () => {
                    if (
                      incentiveAmount === null ||
                      incentiveAmount === undefined ||
                      incentiveAmount === ""
                    ) {
                      toast.error("Please enter incentive amount");
                      return;
                    }

                    if (!staff || !product) {
                      toast.error("Please select staff and product");
                      return;
                    }

                    setLoading(true);
                    const [success, data] = await updateProductIncentive({
                      staffId: staff?._id,
                      productId: product?._id,
                      incentive: +incentiveAmount,
                    });

                    if (success) {
                      toast.success(
                        incentive
                          ? "Incentive updated successfully"
                          : "Incentive added successfully"
                      );
                      getProductIncentiveData({
                        staffId: staff?._id,
                        productId: product?._id,
                      });
                    }
                    setLoading(false);
                  }}
                >
                  {!loading
                    ? incentive
                      ? "Update Incentive"
                      : "Add Incentive"
                    : "Loading..."}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default StaffIncentiveProducts;
